import { UserType } from 'data/types';
import React, { FC, useState } from 'react';
import ButtonPrimary from 'shared/Button/ButtonPrimary';
import Input from 'shared/Input/Input';
import { useUpdatePasswordMutation } from 'store/api';
type AlertType = "warning" | "error" | "success" | null;

export const ChangePassword:FC<{setShowModal:React.Dispatch<React.SetStateAction<boolean>>}> = ({setShowModal}) => {
    const [alert, setAlert] = useState<string | null>(null);
    const [updatePassword] = useUpdatePasswordMutation();
    const [alertType, setAlertType] = useState<AlertType>("error");

    const userData = localStorage.getItem("user");
    let user:UserType;
    if (userData) user = JSON.parse(userData) as UserType;
    
    const handleSubmit = async(e:React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const form = e.currentTarget;
        let isValid = true;
        const fields = form.elements;
        setAlertType('error');

        for (let i = 0; i < fields.length; i++) {
            const field = fields[i] as HTMLInputElement;
            if (field.tagName === "INPUT" && field.type === "password") {
                if (field.value === "") {
                    isValid = false;
                    break;
                }
            }
        }

        if (!isValid) {
            setAlert("Por favor, rellene todos los campos");
            setTimeout(() => setAlert(null), 2500);
            return;
        }
        
        const password = form["oldPassword"].value;
        const newPassword = form["password"].value;
        const repeatPassword = form["repeatPassword"].value;
        if (newPassword !== repeatPassword) {
            setAlert("Las contraseñas no coinciden");
            setTimeout(() => setAlert(null), 2500);
            return;
        }
        
        if (newPassword.length < 4) {
            setAlert("La contraseña debe tener al menos 4 caracteres");
            setTimeout(() => setAlert(null), 2500);
            return;
        }
        
        const {data,error} =await  updatePassword({password, newPassword,_id:user._id});
        if(error){
            if ("status" in error){
                const fetchError = error as { status: number; data: { message: string; statusMessage: string } };
                if (fetchError.status === 409) {
                    setAlert("Contraseña actual incorrecta");
                    setTimeout(() => setAlert(null), 2500);
                    return;
                }else{
                    setAlert("Error al actualizar la contraseña");
                    setTimeout(() => setAlert(null), 2500);
                    return;
                }
            }
        }
        if(data){
            if(data.meta.status === 200){
                setAlertType('success');
                setAlert("Contraseña actualizada");
                setTimeout(() => {
                     setAlert(null);
                     form.reset();
                    return setShowModal(false);
                }, 1500);
            }
        }


    }
  return (
        <div className="flex flex-col sm:flex-row sm:items-center gap-2">
            <div className="max-w-md mx-auto space-y-6 ">
                <form className="grid grid-cols-1 gap-6" onSubmit={handleSubmit}>
                    <label className="block">
                    <Input name="oldPassword" type="password" className="mt-1" placeholder="Contraseña actual"/>
                    </label>
                    <label className="block">
                    <Input name="password" type="password" className="mt-1" placeholder="Nueva contraseña"/>
                    </label>
                    <label className="block">
                    <Input name="repeatPassword" type="password" className="mt-1" placeholder="Repetir contraseña"/>
                    </label>
                    <ButtonPrimary type="submit">Continuar</ButtonPrimary>
                </form>
                {alert && (
                <div
                className={`fixed bottom-8 left-1/2 transform -translate-x-1/2  ${alertType==='warning'?'bg-yellow-600':alertType==='error'?'bg-red-600':'bg-green-600'} text-white px-6 py-3 rounded-2xl shadow-2xl transition-all duration-300 ease-in-out z-50`}
                style={{ opacity: 1 }}
                >
                {alert}
                </div>
                )}
            </div>      
        </div>
    )}
    
  


  